import { useQuery } from '@tanstack/react-query';

import { MOCK_LOTES_SME_MESTRE } from '../dados-simulados';

/**
 * FIN-XXX: fila de aprovação SME sobre a competência apurada (financeiro),
 * distinta do Resumo para Aprovação SME já existente.
 *
 * Busca só por mês, igual ao `useResumoApontamentosSmeAgrupado` real — filtro
 * de DRE/tipo de pessoa/status é aplicado no cliente pela tela, para que os
 * KPIs do topo (que ignoram esses filtros) leiam o mesmo universo completo.
 */
export function useLotesAprovacaoSme(mes: string) {
  return useQuery({
    queryKey: ['financeiro', 'aprovacao-sme', mes],
    queryFn: async () => MOCK_LOTES_SME_MESTRE,
    enabled: mes.length > 0,
  });
}

// Aprovar e devolver NAO tem gancho de gravacao: nao ha rota de aprovacao em
// `apps/api/src/modulos/`. Os dois ganchos que existiam aqui esperavam 500 ms e
// trocavam o status direto no mock — a tela mostrava "aprovado" sem nada ter
// sido gravado, o que o CLAUDE.md proibe ("nunca fingindo gravar"). A tela agora
// mostra o aviso de indisponibilidade; o gancho volta junto com o endpoint.
